// WPI's undergraduate majors (#2743). Read on 2026-10-01 from the official
// 2026-2027 Undergraduate Catalog's Programs of Study list (catalog.wpi.edu,
// which serves the list from WPI's catalog host wpi.cleancatalog.net; the
// group source is the catalog home on catalog.wpi.edu because the .edu link to
// the list itself redirects to a broken address). Every program the list marks
// Bachelor of Science, Bachelor of Arts or Bachelor of Arts/Sciences is kept,
// grouped by the School filter; concentrations, minors and the licensure
// program are left out. Five majors carry no school in the catalog: the four
// Social Science and Policy Studies majors (grouped by that department) and
// International and Global Studies (grouped with The Global School's
// individually designed major, as the catalog's department filter does). The
// "Double Major in Social Science and Policy Studies" is kept as the catalog
// names it. Degree names are the catalog's own, written out; " Major" is
// dropped from each title. Official names "Artificial Intelligence" and
// "Business Analytics and Applied AI" are kept as WPI writes them. The KB's
// majors list was the starting point; the catalog wins.
const majors = {
    "slug": "worcester-polytechnic-institute",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in WPI's official 2026-2027 Undergraduate Catalog, grouped by the school that offers it, with the degree it leads to. Concentrations, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Engineering",
            "source": {
                "label": "WPI Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.wpi.edu/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Robotics Engineering",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Arts & Sciences",
            "source": {
                "label": "WPI Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.wpi.edu/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Bioinformatics and Computational Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology and Biotechnology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Humanities and Arts",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Liberal Arts and Engineering",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Professional Writing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Interactive Media & Game Development",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Interactive Media & Game Development Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Actuarial Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Applied Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Double Major in Social Science and Policy Studies",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "WPI Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.wpi.edu/"
            },
            "majors": [
                {
                    "name": "Business Analytics and Applied AI",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Financial Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Information Systems and Technologies (ISTech)",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Management Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Marketing Analytics",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Social Science and Policy Studies",
            "source": {
                "label": "WPI Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.wpi.edu/"
            },
            "note": "The catalog lists these under the Department of Social Science and Policy Studies without naming a school.",
            "majors": [
                {
                    "name": "Psychological Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Economic Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental and Sustainability Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Policy Studies",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "The Global School",
            "source": {
                "label": "WPI Undergraduate Catalog 2026-2027, Programs of Study",
                "url": "https://catalog.wpi.edu/"
            },
            "note": "The catalog files the individually designed major under The Global School and International and Global Studies under its own program, without naming a school.",
            "majors": [
                {
                    "name": "Interdisciplinary (Individually Designed)",
                    "degree": "Bachelor of Arts/Sciences"
                },
                {
                    "name": "International and Global Studies",
                    "degree": "Bachelor of Science"
                }
            ]
        }
    ]
};

export default majors;
